<div
  [attr.data-test]="dataTest()"
  [attr.title]="ariaTitle() | translate"
  [attr.ngbAutofocus]="hasAutoFocus() ? true : null"
  (click)="!disabled() && cardClicked.emit()"
  (keydown.enter)="!disabled() && cardClicked.emit()"
  [class]="cardClass()"
  [attr.tabindex]="cardTabIndex()"
  [attr.aria-disabled]="disabled()"
>
  <div class="card-basic-body">
    <div class="row h-100 g-2">
      <div class="col">
        <div class="mb-1">
          <mwe-product-icons
            [categories]="categories()"
            [categoryTranslationKeys]="categoryTranslationKeys()"
            [size]="'xl'"
            [textNodeType]="textNodeType()"
          />
        </div>
        <ng-content />
      </div>
      @if (clickable()) {
        <div class="col-auto align-self-center">
          <i class="fas fa-chevron-right text-body"></i>
        </div>
      }
    </div>
  </div>
</div>
